import { z } from "zod";
import { FileDocumentResponseSchema } from "./document.types.js";
/**
 * `POST /api/documents/upload-url` creates the Document row server-side (kind = "file") and
 * returns it alongside a presigned PUT URL. The row is visible immediately in the feed; the
 * client uploads the bytes to Scaleway against `uploadUrl` to make the file actually
 * downloadable.
 *
 * The presigned URL pins `Content-Length` and `Content-Type` so a malicious client cannot
 * upload bytes larger or of a different type than declared at sign time.
 */
export const CreateUploadUrlResponseSchema = z.object({
    document: FileDocumentResponseSchema,
    uploadUrl: z.string().url(),
});
export const PrepareDocumentUploadResponseSchema = z.object({
    document: FileDocumentResponseSchema,
    uploadUrl: z.string().url().nullable(),
    uploadHeaders: z.record(z.string()),
});
//# sourceMappingURL=upload.types.js.map